import React, { FC } from 'react';
import cx from 'classnames';

import styles from './TestimonialShowcase.module.scss';

import { TestimonialAssembly } from 'api/contentful/contentTypes.cloverdotcom';
import { TextSection } from 'components/Testimonial/Text/TextSection';
import { FlatEntry } from 'services/cms/flattenContentful';
import { AppType } from 'services/cms/typesUtil';
import { FadeToastUp } from 'components/Animation/FadeToastUp/FadeToastUp';

type TestimonialShowcaseProps = AppType.Component<
  FlatEntry<TestimonialAssembly> & { hasBackgroundImage?: boolean }
>;

export const TestimonialShowcase: FC<TestimonialShowcaseProps> = ({
  testimony,
  merchant,
  mediaTopic,
  stats,
  hasBackgroundImage,
  ...props
}) => {
  if (!testimony || !merchant) return null;

  return (
    <FadeToastUp>
      <div
        className={cx(styles.testimonialModule, hasBackgroundImage && styles.hasBackgroundImage)}
        {...props}
      >
        <TextSection
          testimony={testimony}
          merchant={merchant}
          stats={stats}
          showCaseVariation
          showOverlay={hasBackgroundImage}
        />
      </div>
    </FadeToastUp>
  );
};
